import { useGraphql } from 'utils/hooks/useGraphql';
import { selectProjects } from 'core/userContext';
import { UserAvatar } from 'modules/workflows/components/UserAvatar/UserAvatar';
import { useSelector } from 'react-redux';
import { displayDate, DATE_FORMAT_FULL_WITH_WEEKDAY_2 } from 'utils/date';
import { getClonedFromJourney, getWorkflow } from '../../../ducks';
import { ClonedFromJourney } from '../../../types';
import { SwitchProjectsLink } from './SwitchProjectsLink';
import {
  modalText,
  WORKFLOW_DETAILS_CREATED_ON_TEXT,
  WORKFLOW_DETAILS_UPDATED_AT_TEXT,
} from './WorkflowDetailsModal.constants';
import { fetchAdditionalDetailsQuery } from './WorkflowDetailsModal.graphql';
import { DateText, Detail, Details, DetailText, UserText } from './WorkflowDetailsModal.styled';

export const JourneyDetails = () => {
  const clonedFromJourney = useSelector(getClonedFromJourney);
  const workflow = useSelector(getWorkflow);
  const { createdAt, updatedAt, id: workflowId } = workflow;

  // used to display message when a cloned-from-journey is deleted
  const projects = useSelector(selectProjects) || [];
  const project = projects.find((p) => p.id === clonedFromJourney?.projectId);
  const isClonedFromJourneyDeleted = clonedFromJourney?.status === 'Deleted';

  // todo: what to do if journey has more than 20 clones?
  const { data } = useGraphql(fetchAdditionalDetailsQuery, {
    variables: {
      id: workflowId,
      workflowType: workflow?.workflowType,
      offset: 0,
      limit: 20,
    },
  });

  const additionalData = data?.workflow;
  const clones = additionalData?.clones?.results;

  return (
    <>
      <Details>
        <Detail>
          <DetailText>{modalText.lastModified}</DetailText>
          <DetailText data-test={WORKFLOW_DETAILS_UPDATED_AT_TEXT}>
            <DateText>{displayDate(updatedAt, DATE_FORMAT_FULL_WITH_WEEKDAY_2)}</DateText>
            {additionalData?.updatedByUserId && (
              <UserText>
                <UserAvatar userId={additionalData.updatedByUserId} showFullName />
              </UserText>
            )}
          </DetailText>
        </Detail>
        <Detail>
          <DetailText>{modalText.createdLabel}</DetailText>
          <DetailText data-test={WORKFLOW_DETAILS_CREATED_ON_TEXT}>
            <DateText>{displayDate(createdAt, DATE_FORMAT_FULL_WITH_WEEKDAY_2)}</DateText>
            {additionalData?.creatorUserId && (
              <UserText>
                <UserAvatar userId={additionalData?.creatorUserId} showFullName />
              </UserText>
            )}
          </DetailText>
        </Detail>
      </Details>
      <Details>
        {!!clones?.length && (
          <Detail>
            <DetailText>{modalText.copiedToLabel}</DetailText>
            <DetailText>
              {clones.map((wf: ClonedFromJourney) => (
                <SwitchProjectsLink workflow={wf} key={wf.id} />
              ))}
            </DetailText>
          </Detail>
        )}
        {clonedFromJourney?.projectId && (
          <Detail>
            <DetailText>{modalText.copiedFromLabel}</DetailText>
            <DetailText>
              {isClonedFromJourneyDeleted ? (
                <p>a deleted journey in {project?.name}</p>
              ) : (
                <SwitchProjectsLink workflow={clonedFromJourney} />
              )}
            </DetailText>
          </Detail>
        )}
      </Details>
    </>
  );
};
